module.exports = __webpack_public_path__ + "img/146.5f11debf.jpg";